// extracted by mini-css-extract-plugin
export var subtitle = "_9r-2";
export var title = "_9r-0";
export var titleNoWrap = "_9r-1";